import { FieldValue, auth } from 'firebase-modules';
import { CardEventType, CardEvent } from '@creative-kit/shared';
import { db } from './data';

/**
 * Write a card event to the events subcollection.
 * Fire-and-forget — failures are logged only so event logging never breaks core operations.
 */
export function emitCardEvent(
  sessionId: string,
  cardId: string,
  type: CardEventType,
  userId: string,
  userEmail: string | null | undefined,
  meta?: Record<string, unknown>,
): Promise<void> {
  const resolvedUserId = userId || auth.currentUser?.uid || '';
  if (!resolvedUserId) {
    return Promise.resolve();
  }

  const ref = db.cardEvents(sessionId, cardId).doc();
  const event: CardEvent = {
    type,
    timestamp: FieldValue.serverTimestamp() as unknown as Date,
    userId: resolvedUserId,
    userEmail: userEmail ?? null,
    ...(meta ? { meta } : {}),
  };
  return ref.set(event).catch((error) => {
    // eslint-disable-next-line no-console
    console.error('[emitCardEvent] Failed to write card event:', {
      sessionId,
      cardId,
      type,
      error,
      hint:
        error?.code === 'permission-denied'
          ? 'Rules require userId === auth.uid and edit access to the session. If updating the card works, deploy latest firestore.rules (sessions/.../cardList/{cardId}/events).'
          : undefined,
    });
  });
}
